import { ChipProps } from '@material-ui/core';
import { ChipX } from 'framework/components/chips/ChipX';
import { Orientation } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { RecordContext } from 'shared/records/RecordContext';

type OrientationChipProps = Omit<ChipProps, 'label' | 'onClick'> & {
	orientation: Orientation;
};

export const OrientationChip = ({ orientation, ...rest }: OrientationChipProps) => {
	const { orientationRecord } = useContext(RecordContext);

	return (
		<ChipX
			size='small'
			variant='outlined'
			label={orientationRecord[orientation]}
			color={orientation === 'Right' ? 'secondary' : orientation === 'Left' ? 'primary' : 'default'}
			// style={{ color: orientation === 'Right' ? 'red' : orientation === 'Left' ? 'blue' : 'unset' }}
			{...rest}
		/>
	);
};

type OrientationChipOrNaProps = Omit<ChipProps, 'label' | 'onClick'> & {
	orientation: string | null | undefined;
};

export const OrientationChipOrNa = ({ orientation, ...rest }: OrientationChipOrNaProps) => {
	const { orientationRecord } = useContext(RecordContext);
	const strings = useLocalization();

	return (
		<ChipX
			size='small'
			variant='outlined'
			label={orientation === 'Left' || orientation === 'Right' ? orientationRecord[orientation] : strings.notApplicableAbbreviation}
			color={orientation === 'Right' ? 'secondary' : orientation === 'Left' ? 'primary' : 'default'}
			{...rest}
		/>
	);
};
